import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferYoutubeMusicToTidal() {
    return (
        <GuidesPage
            seoData={seoContent.transferYoutubeMusicToTidal}
            sections={<PairTransferGuideContent sourceKey="youtubeMusic" destKey="tidal" />}
        />
    );
}
